// extracted by mini-css-extract-plugin
export var container = "OrderApprover-module--container--6WM91";
export var deleteButton = "OrderApprover-module--deleteButton--faTgF";
export var details = "OrderApprover-module--details--e0LED";